import allowed from '@/core/constants/allowed-roles.constant'
import { useGenericSurveyStore } from '../stores/use-generic-survey.store.js'

const routes = [
  {
    name: 'survey-public',
    path: '/survey/:id',
    component: () =>
      import('@/modules/generic-survey/containers/survey-public/survey-public.container.vue'),
    meta: {
      requiresAuth: false,
      layout: 'public',
      module: 'generic-survey',
    },
  },
  {
    name: 'generic-survey',
    path: '/generic-survey',
    meta: {
      requiresAuth: true,
      layout: 'home',
      module: 'generic-survey',
      allowedRoles: [...allowed.generic_survey.roles],
      breadcrumb: {
        label: 'generic-survey.title',
        route: 'survey-list',
      },
    },
    children: [
      {
        name: 'survey-list',
        path: '',
        component: () =>
          import('@/modules/generic-survey/containers/survey-list/survey-list.container.vue'),
        meta: {
          breadcrumb: {
            label: 'generic-survey.surveyList',
            route: 'survey-list',
          },
        },
      },
      {
        name: 'survey-create',
        path: 'new',
        component: () =>
          import('@/modules/generic-survey/containers/survey-create/survey-create.container.vue'),
        meta: {
          breadcrumb: {
            label: 'generic-survey.create.title',
            route: 'survey-create',
          },
        },
      },
      {
        name: 'survey-detail',
        path: ':id',
        component: () =>
          import('@/modules/generic-survey/containers/survey-detail/survey-detail.container.vue'),
        meta: {
          breadcrumb: {
            label: 'generic-survey.detail.title',
            route: 'survey-detail',
          },
        },
      },
      {
        name: 'survey-edit',
        path: ':id/edit',
        component: () =>
          import('@/modules/generic-survey/containers/survey-edit/survey-edit.container.vue'),
        meta: {
          breadcrumb: {
            label: 'generic-survey.editor.title',
            route: 'survey-edit',
          },
        },
        beforeEnter: async (to) => {
          const store = useGenericSurveyStore()
          if (!store.currentSurvey || store.currentSurvey.id !== to.params.id) {
            await store.fetchSurvey(to.params.id)
          }
          if (store.currentSurvey?.status !== 'draft') {
            return { name: 'survey-detail', params: { id: to.params.id } }
          }
        },
      },
    ],
  },
]

export default routes
